import { useEffect, useState } from 'react';
import { filterEmoji } from '../../../util/util';
import './posterForHome.scss';

export default function posterForHome(props) {
  const [posterInfo, updatePosterInfo] = useState({
    isShow:
      props.posterBox.posterArr.isShow !== undefined ? props.posterBox.posterArr.isShow : true,
    pictureImg: props.posterBox.posterArr.pic,
    pictureTitle: '',
    pictureSubtitle: props.posterBox.posterArr.subtitle,
    // flag: false,
    isFocus: props.posterBox.posterArr.isFocus,
    pictureEpisode: {
      type: 0,
      text: '',
    },
    pictureSubscript: {
      text: '',
    },
    indexValue: 0,
    posterAtion: undefined,
    isVip: false,
    isChecked: false,
  });

  useEffect(() => {
    const {
      posterBox: { posterAnimation, posterArr, posterIndex },
      isVip,
      // flag,
      isChecked,
    } = props;
    let pictureEpisode = {
      type: 0,
      text: '',
    };
    let pictureSubscript = {
      text: '',
    };
    if (posterArr.labels !== undefined) {
      const arr = Object.keys(posterArr.labels);
      if (arr.length) {
        for (let i = 0; i < arr.length; i++) {
          if (arr[i] === '1') {
            pictureEpisode = posterArr.labels[arr[i]];
          }
          if (arr[i] === '0') {
            pictureSubscript = posterArr.labels[arr[i]];
          }
        }
      }
    }
    updatePosterInfo({
      isShow: posterArr.isShow !== undefined ? posterArr.isShow : true,
      pictureImg: posterArr.pic,
      pictureTitle: posterArr.title,
      pictureSubtitle: posterArr.subtitle || posterArr.title,
      // flag: posterArr.isFocus,
      // flag,
      isFocus: posterArr.isFocus,
      pictureEpisode,
      pictureSubscript,
      indexValue: posterIndex,
      posterAtion: posterAnimation,
      isVip,
      isChecked,
    });
  }, []);

  useEffect(() => {
    const {
      posterBox: { posterArr },
      // flag,
      isChecked,
    } = props;
    updatePosterInfo(posterInfo => ({
      ...posterInfo,
      isChecked,
      isFocus: posterArr.isFocus,
    }));
  }, [props.isChecked, props.posterBox.posterArr.isFocus]);

  return (
    <div
      className={[
        'homePoster',
        posterInfo.posterAtion === posterInfo.indexValue ? 'posterShake' : null,
        posterInfo.isVip ? 'vip' : 'notVip',
      ].join(' ')}
    >
      <div className="content_img">
        <div
          className='posterImg'
          style={{ backgroundImage: `url(${posterInfo.isShow ? posterInfo.pictureImg : ''})`, backgroundSize: '100% 100%' }}
        />
        {/* eslint-disable-next-line */}
        {posterInfo.isFocus ? null : (
          <div className="pressure">
            {/* 文字压图  */}
            <span className="pressure_title">
              {filterEmoji(posterInfo.pictureTitle || '')}
            </span>
            <span className="pressure_Episode">{posterInfo.pictureEpisode.text}</span>
          </div>
        )}
        {posterInfo.pictureSubscript.text ? (
          <div
            className={[
              posterInfo.pictureSubscript.text === 'VIP' ? 'vipSubscript' : 'subscript',
            ].join(' ')}
          >
            {posterInfo.pictureSubscript.text}
          </div>
        ) : null}
      </div>
      {posterInfo.isFocus ? (
        <div
          className="foot_prompt"
          style={{
            backgroundColor: posterInfo.isVip === 'VIP' ? '#f9ebb1' : '#fff',
          }}
        >
          <div
            className={[posterInfo.isVip === 'VIP' ? 'broadcast_v' : 'broadcast'].join(' ')}
          ></div>
          {
            <span
              className="pressure_Episode"
              style={{ display: posterInfo.pictureEpisode.text ? 'inline-block' : 'none' }}
            >
              {posterInfo.pictureEpisode.text}
            </span>
          }
          <span>
            {filterEmoji(posterInfo.pictureTitle || '')}
          </span>
          {/* eslint-disable-next-line */}
          <span className="foot_Episode"> {posterInfo.pictureSubtitle}</span>
        </div>
      ) : null}
    </div>
  );
}
